import { ensureUserLimitLoaded } from '@/util/userLimitConfig';
import store from '@/redux/stroe';

const CART_PATH = '/cart/carts';

/**
 * 购物车关键接口预取：把用户权限(authority)与路由鉴权(account/me)并行触发。
 * authority 走 cookie、不依赖 me 的返回值，提前发可省掉「me → 渲染 → mount → authority」的串行 RTT；
 * ensureUserLimitLoaded 自带 cached/inflight 去重，组件 mount 再调会命中缓存，不会重复请求。
 */
export function prefetchCartFromPathname(pathname: string): void {
  if (!pathname.startsWith(CART_PATH)) {
    return;
  }
  // 预取失败静默吞掉：仅为提前发起，真正的权限加载仍由组件 mount 兜底
  void ensureUserLimitLoaded(store.dispatch, store.getState()?.UserLimit?.limitData).catch(() => undefined);
}
